/* istanbul ignore file */
import { boolean as codecBoolean, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LoginDataParser = /* #__PURE__ */ parsers.object([
    ['username', codecString],
    ['tenantId', codecString, 'tenant_id'],
    ['password', codecString],
    [
        'confirmSessionTermination',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'confirm_session_termination',
    ],
]);
export class LoginData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LoginDataParser.decode(input).map(res => new LoginData(res));
    }
    static unsafeDecode(input) {
        return LoginData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LoginDataParser.encode(data);
    }
    static schema() {
        return LoginDataParser.schema();
    }
}
